import {Modal} from 'react-bootstrap'
import {ID} from '../../../helpers'
import {TaskModalContentWrapper} from './TaskModalContentWrapper'
import { useSearchParams } from 'react-router-dom'

type Props = {
  show: boolean
  handleClose: () => void | undefined
  stageId?: ID | string
  sprintId?: ID
  initialTaskName?: string
  initialTaskDate?: string
  initialDescription?: string
  initialProjectId?: string | number
  initialPriority?: string
  initialIsPublic?: boolean
  initialAttachments?: Array<{id: number; file: string; file_name: string}>
  initialClientPortalTicketId?: number
  onTaskCreated?: (taskId: number) => void
}

const TaskModal: React.FC<Props> = ({
  show, 
  handleClose, 
  stageId, 
  sprintId, 
  initialTaskName, 
  initialTaskDate,
  initialDescription,
  initialProjectId,
  initialPriority,
  initialIsPublic,
  initialAttachments,
  initialClientPortalTicketId,
  onTaskCreated,
}) => {
  const [searchParams, setSearchParams] = useSearchParams()

  function close(){
    handleClose()

    const params = new URLSearchParams(searchParams)
    params.delete('showCreateTask')
    params.delete('templateId')
    setSearchParams(params)
  }

  return (
    <Modal
      className='px-md-5'
      id='kt_modal_task'
      tabIndex={-1}
      role='dialog'
      show={(show || searchParams.has('showCreateTask'))}
      dialogClassName='mw-1000px modal-dialog-centered'
      aria-hidden='true'
      backdrop='static'
      onHide={close}
      enforceFocus={false}
      autoFocus={false}
    >
      <TaskModalContentWrapper 
        handleClose={close} 
        stageId={stageId} 
        sprintId={sprintId} 
        initialTaskName={initialTaskName} 
        initialTaskDate={initialTaskDate}
        initialDescription={initialDescription}
        initialProjectId={initialProjectId}
        initialPriority={initialPriority}
        initialIsPublic={initialIsPublic}
        initialAttachments={initialAttachments}
        initialClientPortalTicketId={initialClientPortalTicketId}
        onTaskCreated={onTaskCreated}
      />
    </Modal>
  )
}

export {TaskModal}
